import { InjectionToken } from '@angular/core';
import { PasswordRecoveryPort } from './password-recovery.port';

export const PASSWORD_RECOVERY_PORT = new InjectionToken<PasswordRecoveryPort>('PASSWORD_RECOVERY_PORT');
